//AzeemKhan : 17-01-2023 : BT-97769 -  Breeze - Account Registration (eKYC) - Start
import { memo } from "react";
import { BzHeading, BzInputText } from "../../components";
import { Typeahead } from "react-bootstrap-typeahead";
import { Container, Row, Col } from "react-bootstrap";
const Registration = ({ registration, cityOptionData, arrStateOption, setCitySelected, handleChange, handleStateTypeahedChange, cityTypeaheadRef, }) => {

    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0 mb-4'>
                    <Col>
                        <BzHeading className='fontmedium font-size8 color-text'>Register Now!</BzHeading>
                    </Col>
                </Row>
                <Row className='g-0 mb-3'>
                    <Col>
                        <BzInputText className='font-regular color-text' onChange={handleChange} name={"userName"} maxLength={"20"} type={"text"} placeholder={"Name"} autoFocus />
                    </Col>
                </Row>
                <Row className='g-0 mb-3'>
                    <Col className='d-flex align-items-center form-control form-control-sm p-0'>
                        <div className='form-input-disabled input-group-text px-3'>+91</div>
                        <div className='input-group form-control bdr-none no-focus-textbox'>
                            <BzInputText type={'text'} name={"userPhoneNumber"} placeholder={'Phone Number'} onKeyDown={(e) => (e.key === 'e' || e.key === 'E' || e.key === '.' || e.key === '+' || e.key === '-') && e.preventDefault()} onChange={handleChange} className='form-control bdr-none p-0' value={registration['userPhoneNumber']} />
                        </div>
                    </Col>
                </Row>
                <Row className='g-0 mb-3'>
                    <Col>
                        <div className='d-flex form-control form-control-sm p-0 align-items-center'>
                            <Typeahead className='font-regular color-text bdr-none w-100' clearButton id="state" options={arrStateOption ? arrStateOption : []} onChange={handleStateTypeahedChange} placeholder="Select State" />
                            <div className='d-flex flex-column pe-2'>
                                <div className='icon-16 icon-sort-up icon-grey'></div>
                                <div className='icon-16 icon-sort-down icon-grey'></div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className='g-0 mb-3'>
                    <Col>
                        <div className='d-flex form-control form-control-sm p-0 align-items-center'>
                            <Typeahead className='font-regular color-text bdr-none w-100' clearButton id="city" ref={cityTypeaheadRef} options={cityOptionData ? cityOptionData : []} onChange={setCitySelected} placeholder="Select City" />
                            <div className='d-flex flex-column pe-2'>
                                <div className='icon-16 icon-sort-up icon-grey'></div>
                                <div className='icon-16 icon-sort-down icon-grey'></div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className='g-0 mb-3'>
                    <Col>
                        <BzInputText className='font-regular color-text' onChange={handleChange} name={"userEmail"} type={"email"} placeholder={"E-Mail ID"} />
                    </Col>
                </Row>
            </Container>
        </>
    );
};
export default memo(Registration);

